import React from 'react';
import { Loader, Dimmer } from 'semantic-ui-react'

const LoadingComponent = ({active,message}) => {
  return (
    <Dimmer inverted active={active} page={true}>
        <Loader content={message} size="massive"/>
    </Dimmer>
  )
}

export default LoadingComponent;